import { useEffect } from "react";
import "./App.css";
import logo from "./color.png";
import * as microsoftTeams from "@microsoft/teams-js";

function App() {
  useEffect(() => {
    if (window.parent !== window) {
      microsoftTeams.app.initialize().then(() => {
        microsoftTeams.app.getContext().then((context) => {
          console.log("User Info:", context.user);
          console.log("Team Info:", context.team);
          console.log("Channel Info:", context.channel);
        });
      });
    }
  }, []);

  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <div className="start-text">Welcome to Agora Demo App</div>
      </header>
    </div>
  );
}

export default App;
